var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReferral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M14.363 11.883c-.721-.863-1.861-1.466-3.53-1.466H7.5c-3.383 0-4.583 2.475-4.583 4.6 0 1.9 1.008 2.9 2.917 2.9h6.033c.192 0 .302-.204.213-.374a3.74 3.74 0 0 1-.414-1.71 3.74 3.74 0 0 1 2.563-3.56c.169-.055.246-.255.134-.39",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M9.174 8.75a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667M17.5 15.208H16.46v-1.041a.625.625 0 0 0-1.25 0v1.041h-1.042a.625.625 0 0 0 0 1.25h1.042V17.5a.625.625 0 0 0 1.25 0v-1.042H17.5a.625.625 0 0 0 0-1.25"
})));
export default SvgReferral;